const rememberedBatchIds = new Set();

export function rememberSyncCompletedBatch(batchId) {
  if (batchId) rememberedBatchIds.add(String(batchId));
}

export function consumeSyncCompletedBatch(batchId) {
  const id = String(batchId || '');
  if (!id || !rememberedBatchIds.has(id)) return false;
  rememberedBatchIds.delete(id);
  return true;
}

export function resetSyncCompletedBatches() {
  rememberedBatchIds.clear();
}
